import type { ComponentPropsWithoutRef } from 'react';
import { cx } from '../../utils/cx';
import s from './ButtonGroup.module.css';

export type ButtonGroupProps = ComponentPropsWithoutRef<'div'> & {
  /** Stack full-width on phones and sit in a row from md (the default), or always in a row. */
  layout?: 'responsive' | 'row';
  align?: 'start' | 'end' | 'between';
};

/** A set of related buttons. Primary action goes first in source order (and first on phones). */
export function ButtonGroup({
  layout = 'responsive',
  align = 'start',
  className,
  ...rest
}: ButtonGroupProps) {
  return (
    <div
      role="group"
      className={cx(s.group, className)}
      data-layout={layout}
      data-align={align}
      {...rest}
    />
  );
}
